var map = {
	"./01-ubuntu.tsx": 66176,
	"./02-debian.tsx": 80091,
	"./03-redhat-or-centos.tsx": 52548,
	"./04-freebsd.tsx": 90913,
	"./05-docker.tsx": 39317,
	"./06-macos.tsx": 52877,
	"./07-windows.tsx": 63728,
	"./08-linux.tsx": 57590,
	"./09-aws.tsx": 62559
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52165;